import { useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { FUND_ALIAS } from 'common/constants/general';
import { setQueryString } from 'utilities';
import { SetFundQueryParamOptions, UseFundQueryParamReturn } from './useFundQueryParam.types';

const useFundQueryParam = (): UseFundQueryParamReturn => {
  const navigate = useNavigate();
  const location = useLocation();

  const setFundQueryParam = useCallback(
    (params: SetFundQueryParamOptions) => {
      const { fund } = params;

      setQueryString({
        navigate,
        paramName: FUND_ALIAS,
        paramValue: fund,
        pathname: location.pathname,
        searchParams: location.search,
      });
    },
    [navigate, location.pathname, location.search]
  );

  return { setFundQueryParam };
};

export default useFundQueryParam;
